<template>
    <div>
        <!-- <no-data v-show="noDataShow" title='暂无摄像头' ></no-data> -->
        <div class="pageTop">
            <div class='left'>                
                <p  class='title'>{{baseName}}</p>                
            </div>
            <div class='right'>                
                <van-icon name="apps-o" color='#0076bf' size='22' @click="rListShow" style="vertical-align: middle;margin-left:15px"/>                
            </div>
        </div>
        <div  ref='pageMain'  style="overflow:auto;padding:5px 5px 0 5px ">
            <van-panel v-for="(item,index) in cameraList" :key="index" style="margin-bottom:10px" @click="showImagePop(item)">
                <div slot="header" class="van-cell van-panel__header">
                    <div class="van-cell__title">
                        <span>{{item.camera_name}}</span>
                        <div class='van-cell__label'>
                            <span>{{Object.prototype.toString.call(item.uuid) == '[object Number]' ? '捷佳润摄像头':'极飞摄像头'}}</span>
                        </div>
                    </div>                    
                    <div class='van-cell__value van-panel__header-value'>
                        <span :style="{color:item.is_online == 1 ? '#07c160' : '#ee0a24'}">{{item.is_online == 3 ? '' : (item.is_online == 1 ? '在线' : '离线')}}</span>
                    </div>
                </div>
                <div slot='default' style="padding:5px;display:flex;justify-content: flex-end">
                    <van-button  type="info" size="small" @click.stop='ManualImages'>手动拍照</van-button>
                </div>
            </van-panel>
            <van-divider :style="{padding: '0 16px' }">
                    没有更多啦
            </van-divider>
        </div>

        <van-popup  v-model="seeImgShow"  position="right"  get-container="body" :style="{ height: '100%',width:'100%' }">
            <van-nav-bar    left-text="返回" @click-left="seeImgShow = false"    left-arrow/>
            <div class="pageTop" style="padding-top:46px">
                <div class='left'>                
                    <p  class='title'>{{cameraInfo.name}}</p>                
                </div>
                <div class='right'>                
                    <van-icon name="filter-o" color='#0076bf' size='22' @click="rListPopShow =true" style="vertical-align: middle;margin-left:15px;margin-top:5px;color:#2c3e50"/>                    
                    <!-- <van-icon name="apps-o" color='#0076bf' size='22' @click="rListPopShow =true" style="vertical-align: middle;margin-left:5px;margin-top:5px;color:#2c3e50"/>                     -->
                </div>
            </div>
            <div @scroll='listenScroll($event)' style="position:absolute;top:81px;bottom:0;left:0;right:0;overflow:auto;">
                <!-- <no-data v-show="noDataPopShow" title='暂无图片' ></no-data> -->
                <van-grid :border="false" :column-num="2">
                    <van-grid-item  v-for="(item,index) in imagesArr"  :key="index">
                        <lazy-component>
                            <img style='width:100%'   v-lazy="item.src" @click="previewImages(index)">
                            <p>{{item.collect_time}}</p>
                        </lazy-component>
                    </van-grid-item>                    
                </van-grid>                
                <van-divider v-show="endText" :style="{padding: '0 16px' }">
                    没有图片啦
                </van-divider>
            </div>
        </van-popup>
        


    <van-popup closeable  v-model="rListPopShow"  position="right"  get-container="body" :style="{ height: '100%',width:'70%' }">
            <div  style='height:65%;'>
            <van-cell-group title="摄像头列表">                                   
            </van-cell-group>
            <div style='height:75%;overflow:auto'>
            <van-cell  v-for="(item,index) in cameraList" :key="index" @click="changeCamera(item)"   :title="item.camera_name"  >  
                           
            </van-cell>
            </div>
        </div>
        <div >
            <van-cell-group  title="查询日期">
                <van-cell title="开始时间" :value='setStartTime' @click="startTimePop = true" is-link />
                <van-cell title="结束时间" :value='setEndTime' @click="endTimePop = true" is-link />
                <van-button block  style="width:90%;margin: 15px auto" @click='searchImagesBtn'  type="info" size="normal">立即查询</van-button>
            </van-cell-group>

        </div>       
    </van-popup>

    <van-popup v-model="startTimePop" get-container="body" position="bottom" >
        <van-datetime-picker   @cancel='startTimePop = false' @confirm='setStart' @change='startTimeChange'   type="date" />
    </van-popup>
    <van-popup v-model="endTimePop" get-container="body" position="bottom" >
        <van-datetime-picker    @cancel='endTimePop = false' @confirm='setEnd' @change='endTimeChange'   type="date" />
    </van-popup>


        <!-- <van-image-preview  v-model="imgPreview"  :images="images" :start-position='imgIndex'  @change="onImgChange">
            <template v-slot:imgIndex>第{{ imgIndex }}页</template>
        </van-image-preview> -->
        
    </div>
</template>

<script>
import { ImagePreview } from 'vant';
import {getCameraList,getCameraImages} from '@/request/data'
import noData from '@/components/noData.vue'
export default {
    components:{
        noData
    },
    props:{
        uuid:{
            type:[String,Number],
            required: true
        },
        baseName:{
            type:String,
        }
    },
    data() {
        return {
            clientHeight:'',
            noDataShow:true,
            noDataPopShow:true,
            seeImgShow:false,
            rListPopShow:false,
            cameraList:[],
            cameraInfo:{
                name:'',
                uuid:'',
            },
            startTimePop:false,
            startTime:'',
            setStartTime:'',
            endTimePop:false,
            endTime:'',
            setEndTime:'',
            page:1,
            per_page:10,
            imagesArr:[],
            images:[],
            scroll:'',            
            endText:true,
            imgPreview:false,
            imgIndex:0,
        }
    },
    mounted() {
        this.clientHeight =   `${document.documentElement.clientHeight}`
        window.onresize = function temp() {
            this.clientHeight = `${document.documentElement.clientHeight}`;
        };        
        this.getCameraList()
    },
     watch: {
        clientHeight: function () {
            this.changeFixed(this.clientHeight)
        }
    },
    methods: {
        getCameraList(){
            let data = {}
            data.uuid = this.uuid
            // data.token = this.token
            getCameraList(data).then(res=>{
                if (res.data.code ==0 && res.data.data.hasOwnProperty('data')) {
                    if (res.data.data.data.length > 0) {
                        this.noDataShow = false
                        this.cameraList = res.data.data.data
                        for (let i = 0; i < res.data.data.data.length; i++) {
                            if (!res.data.data.data[i].hasOwnProperty('is_online')) {
                                    // console.log(res.data.data.data[i])
                                    this.cameraList[i].is_online = 3
                            }
                            
                        }
                    }else{
                        this.noDataShow = true                        
                    }
                }else{
                    this.noDataShow = true
                }
                console.log(this.cameraList)
            })
        },
        searchImages(){
            this.$toast.loading({message:'加载中',duration: 0});
            this.imagesList = []
            let data ={}
            data.uuid = this.cameraInfo.uuid
            data.start_time = this.setStartTime
            data.end_time = this.setEndTime
            data.page = this.page
            data.per_page = this.per_page
            getCameraImages(data).then(res=>{
                console.log(res.data.data.data)
                this.$toast.clear()
                if (res.data.data.data.length > 0) {                    
                    this.endText = false
                    this.noDataPopShow = false
                    this.imagesList = res.data.data.data                    
                    // this.imagesArr = []
                    for (let i = 0; i < res.data.data.data.length; i++) {
                        let data = {}
                        data.src = res.data.data.data[i].img_path
                        data.collect_time = res.data.data.data[i].collect_time
                        this.imagesArr.push(data)
                        this.images.push(data.src)
                    }
                }else{
                    // this.noDataPopShow = true
                    this.endText = true
                }
            })
        },
        searchImagesBtn(){
            this.imagesArr = []
            this.images = []
            this.page = 1
            this.searchImages()
            this.rListPopShow = false
        },
        showImagePop(data){
            console.log(data)
            this.cameraInfo.name = data.camera_name
            this.cameraInfo.uuid = data.uuid
            this.seeImgShow = true
            this.imagesArr = []//请求前先清空.
            this.images = []//请求前先清空.            
            this.page = 1,
            this.setStartTime = ''
            this.setEndTime = ''
            this.searchImages()//请求图片
        },
        ManualImages(){

        },
        rListShow(){
            this.$emit('rListSon', 3);
        },
        startTimeChange(value){
            let endTimeArr = value.getValues();   
            this.startTime= `${endTimeArr[0]}-${endTimeArr[1]}-${endTimeArr[2]}`
            console.log(this.startTime)     
        },
        endTimeChange(value){
            let endTimeArr = value.getValues();
            this.endTime= `${endTimeArr[0]}-${endTimeArr[1]}-${endTimeArr[2]}`
            console.log(this.endTime)
        },
        setStart(){
           this.setStartTime =this.startTime
           this.startTimePop = false
        },
        setEnd(){
            this.setEndTime =this.endTime
            this.endTimePop = false
        },
        changeCamera(data){
            this.page = 1,
            this.cameraInfo.name = data.camera_name
            this.cameraInfo.uuid = data.uuid
            this.rListPopShow = false
            this.imagesArr = []
            this.images = []
            this.searchImages()

        },
        listenScroll($event){//监听滚动
            var _this = this                
            if ((parseInt($event.target.clientHeight) + parseInt($event.target.scrollTop)) === parseInt($event.target.scrollHeight)) {               
                console.log("到底")
                this.page += 1
                this.searchImages()
            }
        },
        onImgChange(index){
            this.imgIndex = index;
        },
        previewImages(i){
            console.log(i)
            this.imgIndex = i
            ImagePreview({
            images:this.images,
            startPosition: i,
        })
            // this.imgPreview =true
        },
        changeFixed(clientHeight){//动态修改地图高度样式
            this.$nextTick(() => {
                this.$refs.pageMain.style.height = (clientHeight-134)+'px';
            })
        },
    },
}
</script>

<style scoped>

</style>